import {
    createRouter,
    createWebHistory,
    createWebHashHistory
} from 'vue-router'
import {
    getCurrentMenu
} from '@/api/system.js'
import store from '@/store'

const routes = [{
        path: "/",
        redirect: "/public"
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/public/login.vue"),
    },
    {
        path: "/public",
        name: "public",
        component: () => import("../views/public/index.vue"),
        children: [{
                path: "/refresh",
                component: () => import("../views/public/refresh.vue"),
            },
            {
                path: 'system',
                redirect: '/system/user',
                children: [{
                        path: '/system/user',
                        meta: {
                            title: '用户管理',
                            name: 'system_user',
                            keepAlive: true
                        },
                        component: () => import('../views/system/user/userIndex.vue')
                    },
                    {
                        path: '/system/useradd',
                        meta: {
                            title: '新增用户',
                            name: 'system_user_add',
                            keepAlive: false
                        },
                        component: () => import('../views/system/user/userOp.vue')
                    },
                    {
                        path: '/system/usersave',
                        meta: {
                            title: '编辑用户',
                            name: 'system_user_edit',
                            keepAlive: false
                        },
                        component: () => import('../views/system/user/userOp.vue')
                    },
                    {
                        path: '/system/menu',
                        meta: {
                            title: '菜单管理',
                            name: 'system_menu',
                            keepAlive: true
                        },
                        component: () => import('../views/system/menu/menuIndex.vue')
                    },
                    {
                        path: '/system/menuadd',
                        meta: {
                            title: '新增菜单',
                            name: 'system_menu_add',
                            keepAlive: false
                        },
                        component: () => import('../views/system/menu/menuOp.vue')
                    },
                    {
                        path: '/system/menusave',
                        meta: {
                            title: '编辑菜单',
                            name: 'system_menu_save',
                            keepAlive: false
                        },
                        component: () => import('../views/system/menu/menuOp.vue')
                    },
                    {
                        path: '/system/role',
                        meta: {
                            title: '角色管理',
                            name: 'system_role',
                            keepAlive: true
                        },
                        component: () => import('../views/system/role/roleIndex.vue')
                    },
                    {
                        path: '/system/roleadd',
                        meta: {
                            title: '新增角色',
                            name: 'system_role_add',
                            keepAlive: false
                        },
                        component: () => import('../views/system/role/roleOp.vue')
                    },
                    {
                        path: '/system/rolesave',
                        meta: {
                            title: '编辑角色',
                            name: 'system_role_edit',
                            keepAlive: false
                        },
                        component: () => import('../views/system/role/roleOp.vue')
                    },
                ]
            },
            {
                path: 'banner',
                redirect: '/banner/index',
                children: [{
                    path: '/banner/index',
                    meta: {
                        title: '横幅图片',
                        name: 'banner',
                        keepAlive: true
                    },
                    component: () => import('../views/banner/index.vue')
                }]
            },
            {
                path: 'category',
                redirect: '/category/index',
                children: [{
                    path: '/category/index',
                    meta: {
                        title: '类目',
                        name: 'category',
                        keepAlive: true
                    },
                    component: () => import('../views/category/index.vue')
                }]
            }, {
                path: 'materials',
                redirect: '/materials/index',
                children: [{
                    path: '/materials/index',
                    meta: {
                        title: '学习资料',
                        name: 'materials',
                        keepAlive: true
                    },
                    component: () => import('../views/materials/index.vue')
                }, {
                    path: '/materials/add',
                    meta: {
                        title: '新增学习资料',
                        name: 'materials_add',
                        keepAlive: false
                    },
                    component: () => import('../views/materials/add.vue')
                }, {
                    path: '/materials/modify',
                    meta: {
                        title: '编辑学习资料',
                        name: 'materials_modify',
                        keepAlive: false
                    },
                    component: () => import('../views/materials/add.vue')
                }, {
                    path: '/materials/info',
                    meta: {
                        title: '学习资料详情',
                        name: 'materials_info',
                        keepAlive: false
                    },
                    component: () => import('../views/materials/info.vue')
                }]
            }, {
                path: 'user',
                redirect: '/user/manage',
                children: [{
                    path: '/user/manage',
                    meta: {
                        title: '用户管理',
                        name: 'user_manage',
                        keepAlive: true
                    },
                    component: () => import('../views/user/info.vue')
                }, {
                    path: '/user/inviteNew',
                    meta: {
                        title: '邀请列表',
                        name: 'user_inviteNew',
                        keepAlive: true
                    },
                    component: () => import('../views/user/inviteNew.vue')
                }, {
                    path: '/user/group',
                    meta: {
                        title: '群数据列表',
                        name: 'user_group',
                        keepAlive: true
                    },
                    component: () => import('../views/user/group.vue')
                }]
            }, {
                path: 'channel',
                redirect: '/channel/index',
                children: [{
                    path: '/channel/index',
                    meta: {
                        title: '渠道',
                        name: 'channel',
                        keepAlive: true
                    },
                    component: () => import('../views/channel/index.vue')
                }]
            }, {
                path: 'group',
                redirect: '/group/groupCodeList',
                children: [{
                    path: '/group/groupCodeList',
                    meta: {
                        title: '入群码列表',
                        name: 'group_code',
                        keepAlive: true
                    },
                    component: () => import('../views/group/groupCode.vue')
                }, {
                    path: '/group/groupList',
                    meta: {
                        title: '企微群列表',
                        name: 'group_info',
                        keepAlive: true
                    },
                    component: () => import('../views/group/groupList.vue')
                }]
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// 确保在内页时刷新页面导致vuex中存储的权限列表没了无法判断
router.beforeEach((to, form, next) => {
    document.title = '管理系统';

    if (to.path == '/login' || !localStorage.getItem('token')) {
        return next()
    }

    let menuList = store.state.menuList
    if (menuList.length < 1) {
        getCurrentMenu().then(res => {
            store.commit('setMenuList', res.list)
            store.commit('setOperation', res.operation)
            next()
        })
    } else {
        next()
    }
})

export default router